<template lang='pug'>
  #app
    Cabecalho(v-if="!estaNaRotaDeAcessoNegado")
    router-view
    RecaptchaModal(v-if="mostrarModalRecaptcha")
    .sso-loading(v-if="executingSAMLLogin")
      h1 Realizando login por SSO...

    Footer(v-if="!estaNaRotaDeAcessoNegado")
</template>

<script>
import Cabecalho from '@/components/Cabecalho/Cabecalho.vue'
import Footer from '@/components/Footer/Footer.vue'
import RecaptchaModal from '@/components/Coletor/Recaptcha/RecaptchaModal.vue'

export default {
  components: {
    Cabecalho,
    Footer,
    RecaptchaModal
  },
  async beforeMount () {
    // fetch default styles we will use they if this device is not registred yet
    const visuals = this.$store.state.visualConfigs

    if (visuals && visuals.fileWeb && visuals.visual) {
      const cssFiles = {
        fileUrl: visuals.fileWeb,
        faviconUrl: visuals.visual.favicon
      }
      this.$store.dispatch('_getFileVisual', cssFiles)
    } else {
      await this.$store.dispatch('getVisual')
    }
  },
  computed: {
    executingSAMLLogin () {
      return this.$store.state.executingSAMLLogin
    },
    estaNaRotaDeAcessoNegado () {
      return this.$route.name === 'AcessoNegado'
    },
    mostrarModalRecaptcha () {
      return this.$store.state.modalRecaptcha
    }
  }
}
</script>

<style>
#app {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: fit-content(120px) auto 100px;
  height: 100%;
}
input[type=tel] {
  -webkit-text-security: disc!important;
}
.sso-loading {
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
}
</style>
